import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import VendorFilter from './vendormasters-filter';
import VendorTable from './vendormasters-table';
import VendorTile from './vendormasters-tile';
import VendorSearch from './vendormasters-search';
import { selectVendorFilterVisible, selectTileView } from './store/selectors';
import { fetchVendorsWithFilters, actions } from './store/slice';

const { resetFilters } = actions;

const VendorContent = ({ onEditVendor }) => {
  const dispatch = useDispatch();
  const isFilterVisible = useSelector(selectVendorFilterVisible);
  const showTileView = useSelector(selectTileView);

  useEffect(() => {
    dispatch(fetchVendorsWithFilters());
    return () => {
      dispatch(resetFilters());
    };
  }, [dispatch]);

  return (
    <div className="card table-list-card">
      <div className="card-body">
        <div className="table-top">
          <VendorSearch />
        </div>
        {isFilterVisible && <VendorFilter />}

        {!showTileView ? <VendorTable onEditVendor={onEditVendor} /> : <VendorTile onEditVendor={onEditVendor} />}
      </div>
    </div>
  );
};

export default VendorContent; 